import { PlayArrow } from "@material-ui/icons";

  
export default [
    {
      id: 0,
      name: "Play File",
      icon: <PlayArrow></PlayArrow>,
    },
  ];